import {
  HsaKnockoutStep,
  hsaKnockoutStepSchema,
} from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  FrontendStepType,
  PartialWithRequiredType,
  StepTypeDetailsProps,
} from "..";
import { HsaTextField } from "./hsa-inspector-inputs";
import { HsaInspectorShell } from "./hsa-inspector-shell";

type KnockoutStep = PartialWithRequiredType<HsaKnockoutStep>;

const HsaKnockoutInspector = memo(function HsaKnockoutInspector(
  props: StepTypeDetailsProps<KnockoutStep>,
) {
  const { t } = useTranslation();
  const { step, setStep, onClose, readonly } = props;
  return (
    <HsaInspectorShell onClose={onClose} title={t("Knockout")}>
      <Text fontSize="xs" textColor="secondary">
        {t(
          "Shoppers who reach this step are disqualified: the questionnaire ends here and no Letter of Medical Necessity is generated.",
        )}
      </Text>
      {readonly ? (
        <Flex dir="column" gap="xs">
          <Text fontSize="xxs" textColor="secondary">
            {t("Reason")}
          </Text>
          {step.reason ? (
            <Flex w="full">
              <RedoBadge color="error" size="xs" text={step.reason} />
            </Flex>
          ) : (
            <Text fontSize="sm" textColor="secondary">
              {t("No reason recorded.")}
            </Text>
          )}
        </Flex>
      ) : (
        <HsaTextField
          description={t(
            "Machine-readable, for failure routing and analytics — e.g. 'under-18.'",
          )}
          label={t("Reason")}
          onCommit={(reason) => setStep({ ...step, reason })}
          placeholder="under-18"
          value={step.reason}
        />
      )}
    </HsaInspectorShell>
  );
});

export const hsaKnockoutStepType: FrontendStepType<KnockoutStep> = {
  type: "custom",
  valid: (step) => hsaKnockoutStepSchema.safeParse(step).success,
  customInspector: HsaKnockoutInspector,
};
